
const fieldsLogicData = {
    invoice: {
        paymentTermId: [
            // this recalculates the paymentDate when Payment Term is changed
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'paymentTermId',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            // this sets the value of PaymentDataCalculation to payment Term when Payment Term is changed
            {
                id: 'calcPaymentTerm',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentTerm'
            },
            // this resets the Payments array when we change the Payment Term
            // It calculates Installments if paymentSchedule is true
            {
                id: 'calcPayments',
                logicType: 'calcFields',
                operationType: 'sub.calcPayments',
                conditionField: 'paymentTermId',
                subEntity: 'payments',
                transferMap: {
                    'paymentDate': 'paymentDate',
                    'totalGrossSalesAmount': 'paymentAmount',
                    'currency': 'paymentCurrency',
                    'totalGrossSalesAmountBaseCurrency': 'paymentAmountBaseCurrency'
                }
            },

        ],
        paymentDate: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentDate'
            }
        ],
        date: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'date',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            {
                id: 'calcPaymentTerm',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentTerm'
            },
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
        currency: [
            {
                id: 'recalcInvoiceLines',
                logicType: 'reCalc',
                reCalcData: 'invoiceLines'
            }
        ],
        campaignId: [
            {
                id: 'recalcInvoicePriceList',
                logicType: 'reCalc',
                reCalcData: 'invoicePriceList'
            },
            {
                id: 'recalcInvoiceLines',
                logicType: 'reCalc',
                reCalcData: 'invoiceLines'
            }
        ],
        priceListId: [
            {
                id: 'recalcInvoiceLines',
                logicType: 'reCalc',
                reCalcData: 'invoiceLines'
            }
        ],
    },
    creditNote: {
        paymentTermId: [
            // this recalculates the paymentDate when Payment Term is changed
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'paymentTermId',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            // this sets the value of paymentDateCalculation to paymentTerm when Payment Term is changed
            {
                id: 'calcPaymentTerm',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentTerm'
            },
            // this resets the Payments array when we change the Payment Term
            // It calculates Installments if paymentSchedule is true
            {
                id: 'calcPayments',
                logicType: 'calcFields',
                operationType: 'sub.calcPayments',
                conditionField: 'paymentTermId',
                subEntity: 'payments',
                transferMap: {
                    'paymentDate': 'paymentDate',
                    'totalGrossSalesAmount': 'paymentAmount',
                    'currency': 'paymentCurrency',
                    'totalGrossSalesAmountBaseCurrency': 'paymentAmountBaseCurrency'
                }
            },
        ],
        paymentDate: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentDate'
            }
        ],
        date: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'date',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            {
                id: 'calcPaymentTerm',
                logicType: 'calcFields',
                operationType: 'header.setValue',
                fieldToSet: ['paymentDateCalculation'],
                valueToSet: 'paymentTerm'
            },
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
    },
    quote: {
        date: [
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
        currency: [
            {
                id: 'recalcQuoteLines',
                logicType: 'reCalc',
                reCalcData: 'quoteLines'
            }
        ],
        campaignId: [
            {
                id: 'recalcQuotePriceList',
                logicType: 'reCalc',
                reCalcData: 'quotePriceList'
            },
            {
                id: 'recalcQuoteLines',
                logicType: 'reCalc',
                reCalcData: 'quoteLines'
            }
        ],
        priceListId: [
            {
                id: 'recalcQuoteLines',
                logicType: 'reCalc',
                reCalcData: 'quoteLines'
            }
        ],
    },
    priceList: {
        typeId: [
            {
                id: 'resetTypeId',
                logicType: 'reset',
                operationType: 'header.reset',
                changeField: 'typeId',
                fieldsToReset: [{ id: 'resetId', field: 'id', value: '' }, { id: 'resetIdName', field: 'idName', value: '' }, { id: 'resetValue', field: 'value', value: 0 }]
            }
        ],
    },
    contact: {
        customerGroup: [{
            id: 'recalcContactPriceList',
            logicType: 'reCalc',
            reCalcData: 'contactPriceList'
        }]
    },
    productFamily: {
        name: [
            {
                id: 'calcSku',
                logicType: 'calcFields',
                operationType: 'header.slugField',
                sourceField: 'name',
                targetField: 'sku',
                maxLength: 5,
                onlyIfEmpty: true
            }
        ],
        netSalesPrice: [
            {
                id: 'calcGrossSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 * (1 + $2)',
                args: ['netSalesPrice', 'taxRate'],
                targetField: 'grossSalesPrice'
            }
        ],
        grossSalesPrice: [
            {
                id: 'calcNetSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 / (1 + $2)',
                args: ['grossSalesPrice', 'taxRate'],
                targetField: 'netSalesPrice'
            }
        ],
        taxId: [
            {
                id: 'calcGrossSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 * (1 + $2)',
                args: ['netSalesPrice', 'taxRate'],
                targetField: 'grossSalesPrice'
            }
        ]
    },
    product: {
        name: [
            {
                id: 'calcSku',
                logicType: 'calcFields',
                operationType: 'header.slugField',
                sourceField: 'name',
                targetField: 'sku',
                maxLength: 5,
                onlyIfEmpty: true
            }
        ],
        netSalesPrice: [
            {
                id: 'calcGrossSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 * (1 + $2)',
                args: ['netSalesPrice', 'taxRate'],
                targetField: 'grossSalesPrice'
            }
        ],
        grossSalesPrice: [
            {
                id: 'calcNetSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 / (1 + $2)',
                args: ['grossSalesPrice', 'taxRate'],
                targetField: 'netSalesPrice'
            }
        ],
        taxId: [
            {
                id: 'calcGrossSalesPrice',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 * (1 + $2)',
                args: ['netSalesPrice', 'taxRate'],
                targetField: 'grossSalesPrice'
            }
        ]
    },
    purchaseOrder: {
        date: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'date',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
        paymentTermId: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'paymentTermId',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            }
        ],
        currency: [
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ]
    },
    expense: {
        date: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'date',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            },
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
        paymentTermId: [
            {
                id: 'calcPaymentDate',
                logicType: 'calcFields',
                operationType: 'header.dateByDays',
                conditionField: 'paymentTermId',
                fieldsToSum: ['date', 'paymentTermDays'],
                targetField: 'paymentDate'
            }
        ],
        currency: [
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ]
    },
    paymentTransaction: {
        date: [
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ],
        currency: [
            {
                id: 'getExchangeRate',
                logicType: 'getData',
                operationType: 'getExchangeRate',
                targetField: 'exchangeRate'
            }
        ]
    },
    journal: {
        baseCurrency: [
            {
                id: 'syncLinesCurrency',
                logicType: 'calcFields',
                operationType: 'sub.setFromRoot',
                subEntity: 'lines',
                fields: ['baseCurrency', 'transactionCurrency']
            }
        ]
    },
    workOperation: {
        setupTime: [
            {
                id: 'calcTotalTime',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 + ($2 * $3) + $4 + $5',
                args: ['setupTime', 'runTimePerUnit', 'plannedQty', 'moveTime', 'queueTime'],
                targetField: 'totalTime',
                decimals: 2
            }
        ],
        runTimePerUnit: [
            {
                id: 'calcTotalTime',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 + ($2 * $3) + $4 + $5',
                args: ['setupTime', 'runTimePerUnit', 'plannedQty', 'moveTime', 'queueTime'],
                targetField: 'totalTime',
                decimals: 2
            }
        ],
        queueTime: [
            {
                id: 'calcTotalTime',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 + ($2 * $3) + $4 + $5',
                args: ['setupTime', 'runTimePerUnit', 'plannedQty', 'moveTime', 'queueTime'],
                targetField: 'totalTime',
                decimals: 2
            }
        ],
        moveTime: [
            {
                id: 'calcTotalTime',
                logicType: 'calcFields',
                operationType: 'header.formula',
                formula: '$1 + ($2 * $3) + $4 + $5',
                args: ['setupTime', 'runTimePerUnit', 'plannedQty', 'moveTime', 'queueTime'],
                targetField: 'totalTime',
                decimals: 2
            }
        ]
    },
}

export default fieldsLogicData